/**
 * Domain API del módulo POS — tipos puros con cero dependencias en infra/app/store/ui.
 * Importar desde acá para evitar require cycles.
 *
 * NOTA: `pos/domain/posParkedSaleTypes` NO se incluye acá porque importa `CartItem`
 * desde `../store/usePosStore` (no es un archivo de dominio puro). Sus tipos viven en app-api.
 */

export type {
  PosCheckoutCustomerOption,
  PosDraftPayment,
  PosFiscalMode,
  PosPaymentMethodId,
  PosPaymentMethodRow,
  PosSaleLineInput,
  PosStockNoticeVariant,
  PosStockSalePolicy,
  PosStockWarningDetail,
  PosStockWarningsResult,
} from './domain/posTypes';
